module.exports = __webpack_public_path__ + "static/media/guarantee-faq-hero.7776154c.jpg";